/** Bewaart de pagina waar de gebruiker heen wilde vóór het aanmelden. */
const STORAGE_KEY = "goproprojects.auth.redirect";

export const DEFAULT_AFTER_LOGIN_PATH = "/admin/pagespeed";

export function rememberIntendedPath(path: string) {
  if (typeof window === "undefined") return;
  // Alleen interne paden; nooit een adres op een ander domein.
  if (!path.startsWith("/") || path.startsWith("//")) return;
  if (path.startsWith("/auth")) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // Opslag geblokkeerd: we vallen terug op de standaardpagina.
  }
}

export function takeIntendedPath(): string {
  if (typeof window === "undefined") return DEFAULT_AFTER_LOGIN_PATH;
  try {
    const value = window.sessionStorage.getItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY);
    if (value && value.startsWith("/") && !value.startsWith("//")) return value;
  } catch {
    // Opslag geblokkeerd: we vallen terug op de standaardpagina.
  }
  return DEFAULT_AFTER_LOGIN_PATH;
}
